// import { formattedAmount } from "../../../../utils/helpers/Functions.helper";

import { formattedAmount } from "../../../utils/helpers/Functions.helper";

// const TaxData = ({ key, item }) => {
//     if (item?.sales_price) {
//       return (
//         <div key={`t-${key}`}>
//           <table class="min-w-full bg-white border border-lightGrayColor">
//             <thead>
//               <tr class="bg-gray-100 border-b">
//                 <th class="px-4 py-2 text-left text-[#4A5568] font-semibold">
//                   Tax Name
//                 </th>
//                 <th class="px-4 py-2 text-left text-[#4A5568] font-semibold">
//                   Tax
//                 </th>
//                 <th class="px-4 py-2 text-left text-[#4A5568] font-semibold text-right">
//                   Amount
//                 </th>
//               </tr>
//             </thead>
//             <tbody>
//               <tr class="border-b">
//                 <td class="px-4 py-2 text-left text-gray-700">
//                   Product Base Price
//                 </td>
//                 <td></td>
//                 <td class="px-4 py-2 text-gray-700 text-right">
//                   {formattedAmount(
//                     parseFloat(
//                       item?.sales_price?.$numberDecimal
//                         ? item?.sales_price?.$numberDecimal
//                         : item?.sales_price
//                     ).toFixed(2)
//                   )}
//                 </td>
//               </tr>
//               {item?.taxData?.standardTax?.map((t, i) => (
//                 <tr class="border-b" key={i}>
//                   <td class="px-4 py-2 text-gray-700">{t.name}</td>
//                   <td class="px-4 py-2 text-gray-700">
//                     {t?.rate.$numberDecimal || t?.rate}%
//                   </td>
//                   <td class="px-4 py-2 text-gray-700 text-right">
//                     {formattedAmount(
//                       t?.taxAmount?.$numberDecimal || t?.taxAmount
//                     )}
//                   </td>
//                 </tr>
//               ))}
//               <tr class="border-b">
//                 <td class="px-4 py-2 text-left text-[#4A5568]">Line Rebase</td>
//                 <td></td>
//                 <td class="px-4 py-2 text-gray-700 text-right">
//                   {formattedAmount(
//                     item?.taxData?.rebase?.$numberDecimal || item?.taxData?.rebase
//                   )}
//                 </td>
//               </tr>
//               <tr class="border-b">
//                 <td class="px-4 py-2 text-left text-[#4A5568]">Referral Fee</td>
//                 <td className="px-4 py-2 text-gray-700">
//                   {item?.taxData?.adminEarning?.referralFee?.percentage?.$numberDecimal ||
//                     item?.taxData?.adminEarning?.referralFee?.percentage}
//                   %
//                 </td>
//                 <td class="px-4 py-2 text-gray-700 text-right">
//                   {formattedAmount(
//                     item?.taxData?.adminEarning?.referralFee?.amount?.$numberDecimal ||
//                       item?.taxData?.adminEarning?.referralFee?.amount
//                   )}
//                 </td>
//               </tr>
//               <tr class="border-b">
//                 <td class="px-4 py-2 text-left text-[#4A5568]">Closing Fee</td>
//                 <td className="px-4 py-2 text-gray-700">
//                   {item?.taxData?.adminEarning?.closingFeeRate?.$numberDecimal ||
//                     item?.taxData?.adminEarning?.closingFeeRate}
//                 </td>
//                 <td class="px-4 py-2 text-gray-700 text-right">
//                   {formattedAmount(
//                     item?.taxData?.adminEarning?.closingFee?.$numberDecimal ||
//                       item?.taxData?.adminEarning?.closingFee
//                   )}
//                 </td>
//               </tr>
//               <tr class="border-b">
//                 <td class="px-4 py-2 text-left text-[#4A5568]">Additional Fee</td>
//                 <td className="px-4 py-2 text-gray-700">
//                   {item?.taxData?.additionalFee?.$numberDecimal ||
//                     item?.taxData?.additionalFee}
//                 </td>
//                 <td class="px-4 py-2 text-gray-700 text-right">
//                   {formattedAmount(
//                     item?.taxData?.adminEarning?.additionalFee?.$numberDecimal ||
//                       item?.taxData?.adminEarning?.additionalFee
//                   )}
//                 </td>
//               </tr>
//               <tr class="border-b">
//                 <td class="px-4 py-2 text-left text-[#4A5568]">Taxable Amount</td>
//                 <td></td>
//                 <td class="px-4 py-2 text-gray-700 text-right">
//                   {formattedAmount(
//                     item?.taxData?.taxableAmount?.$numberDecimal ||
//                       item?.taxData?.taxableAmount
//                   )}
//                 </td>
//               </tr>
//               <tr class="border-b">
//                 <td class="px-4 py-2 text-left text-[#4A5568]">VAT Included</td>
//                 <td className="px-4 py-2 text-gray-700">
//                   {item?.taxData?.vat[0]?.rate?.$numberDecimal ||
//                     item?.taxData?.vat[0]?.rate}
//                   %
//                 </td>
//                 <td class="px-4 py-2 text-gray-700 text-right">
//                   {formattedAmount(
//                     item?.taxData?.vat[0]?.taxAmount?.$numberDecimal ||
//                       item?.taxData?.vat[0]?.taxAmount
//                   )}
//                 </td>
//               </tr>
//               <tr class="border-b">
//                 <td class="px-4 py-2 text-left text-[#4A5568]">Grand Total</td>
//                 <td className="px-4 py-2 text-gray-700"></td>
//                 <td class="px-4 py-2 text-gray-700 text-right">
//                   {formattedAmount(
//                     item?.taxData?.grandTotal?.$numberDecimal ||
//                       item?.taxData?.grandTotal
//                   )}
//                 </td>
//               </tr>
//             </tbody>
//           </table>
//         </div>
//       );
//     }
//   };

//   export default TaxData



// const TaxData = ({
//   key,
//   item,
//   ProductDeatils,
//   deliveryDetails,
//   vendorDetails,
// }) => {
//   if (item?.sales_price) {
//     return (
//       <div id="invoice-POS" key={`t-${key}`} className="printable">
//         <center id="top">
//           <div className="logo"></div>
//           <div className="info">
//             <h2>e-Delivery</h2>
//           </div>
//           <hr />
//         </center>
//         <div>
//           <h3 style={{ fontWeight: "700" }}>Order by</h3>
//           <p className="">{deliveryDetails?.name ?? "N/A"}</p>
//           <p className="">{deliveryDetails?.phone_number ?? "N/A"}</p>
//           <p className="text-gray-700">
//             {deliveryDetails?.flat_no ?? "N/A"},{" "}
//             {deliveryDetails?.landmark ?? "N/A"},
//             {deliveryDetails?.street ?? "N/A"},{" "}
//             {deliveryDetails?.pin_code ?? "N/A"}
//           </p>
//         </div>
//         <hr />
//         <div>
//           <h3 style={{ fontWeight: "700" }}>Vendor Details</h3>
//           <p>{vendorDetails?.first_name || ""}</p>
//         </div>
//         <hr />
//         <div>
//           <h3 style={{ fontWeight: "700" }}>Product Details</h3>
//           <p>
//             <b>Product:</b> {ProductDeatils?.product?.name || ""}
//           </p>
//           <p>
//             <b>Quantity:</b> {ProductDeatils?.quantity || ""}
//           </p>
//           <p>
//             Product Base Price:{" "}
//             {formattedAmount(
//               parseFloat(
//                 item?.sales_price?.$numberDecimal || item?.sales_price
//               ).toFixed(2)
//             )}
//           </p>
//         </div>

//         <div id="mid">
//           <div className="info">
//             <h3>Tax Details</h3>
//           </div>
//         </div>

//         <div id="bot">
//           <table>
//             <thead>
//               <tr>
//                 <th>Tax Name</th>
//                 <th>Rate</th>
//                 <th>Amount</th>
//               </tr>
//             </thead>
//             <tbody>
//               {item?.taxData?.standardTax?.map((t, i) => (
//                 <tr key={i}>
//                   <td>{t.name}</td>
//                   <td>{t?.rate.$numberDecimal || t?.rate}%</td>
//                   <td>
//                     {formattedAmount(
//                       t?.taxAmount?.$numberDecimal || t?.taxAmount
//                     )}
//                   </td>
//                 </tr>
//               ))}

//               <tr>
//                 <td>Line Rebase</td>
//                 <td></td>
//                 <td>
//                   {formattedAmount(
//                     item?.taxData?.rebase?.$numberDecimal ||
//                       item?.taxData?.rebase
//                   )}
//                 </td>
//               </tr>
//               <tr>
//                 <td>Referral Fee</td>
//                 <td>
//                   {item?.taxData?.adminEarning?.referralFee?.percentage
//                     ?.$numberDecimal ||
//                     item?.taxData?.adminEarning?.referralFee?.percentage}
//                   %
//                 </td>
//                 <td>
//                   {formattedAmount(
//                     item?.taxData?.adminEarning?.referralFee?.amount
//                       ?.$numberDecimal ||
//                       item?.taxData?.adminEarning?.referralFee?.amount
//                   )}
//                 </td>
//               </tr>
//               <tr>
//                 <td>Closing Fee</td>
//                 <td>
//                   {item?.taxData?.adminEarning?.closingFeeRate
//                     ?.$numberDecimal ||
//                     item?.taxData?.adminEarning?.closingFeeRate}
//                 </td>
//                 <td>
//                   {formattedAmount(
//                     item?.taxData?.adminEarning?.closingFee?.$numberDecimal ||
//                       item?.taxData?.adminEarning?.closingFee
//                   )}
//                 </td>
//               </tr>
//               <tr>
//                 <td>Additional Fee</td>
//                 <td>
//                   {item?.taxData?.additionalFee?.$numberDecimal ||
//                     item?.taxData?.additionalFee}
//                 </td>
//                 <td>
//                   {formattedAmount(
//                     item?.taxData?.adminEarning?.additionalFee
//                       ?.$numberDecimal ||
//                       item?.taxData?.adminEarning?.additionalFee
//                   )}
//                 </td>
//               </tr>
//               <tr>
//                 <td>Taxable Amount</td>
//                 <td></td>
//                 <td>
//                   {formattedAmount(
//                     item?.taxData?.taxableAmount?.$numberDecimal ||
//                       item?.taxData?.taxableAmount
//                   )}
//                 </td>
//               </tr>
//               <tr>
//                 <td>VAT Included</td>
//                 <td>
//                   {item?.taxData?.vat[0]?.rate?.$numberDecimal ||
//                     item?.taxData?.vat[0]?.rate}
//                   %
//                 </td>
//                 <td>
//                   {formattedAmount(
//                     item?.taxData?.vat[0]?.taxAmount?.$numberDecimal ||
//                       item?.taxData?.vat[0]?.taxAmount
//                   )}
//                 </td>
//               </tr>
//               <tr>
//                 <td>Grand Total</td>
//                 <td></td>
//                 <td>
//                   {formattedAmount(
//                     item?.taxData?.grandTotal?.$numberDecimal ||
//                       item?.taxData?.grandTotal
//                   )}
//                 </td>
//               </tr>
//             </tbody>
//           </table>
//         </div>
//       </div>
//     );
//   }
// };



const TaxData = ({
  key,
  item,
  ProductDeatils,
  deliveryDetails,
  vendorDetails,
}) => {
  if (item?.sales_price) {
    return (
      <div id="invoice-POS" key={`t-${key}`} className="printable">
        <center  id="">
          <div className="logo"></div>
          <div  className="info">
            <h2>e-Delivery</h2>
            <h4>Tax Invoice</h4>
          </div>
          <hr />
        </center> 
        {deliveryDetails?(<div>
          <h3 style={{ fontWeight: "700", marginBottom: "8px" }}>Order by</h3>
          <div style={{ fontWeight: "700", marginBottom: "8px" }}>{deliveryDetails?.name ?? "N/A"}</div>
          <div style={{ fontWeight: "700", marginBottom: "8px" }}>{deliveryDetails?.phone_number ?? "N/A"}</div>
          <div className="text-gray-700">
            {deliveryDetails?.flat_no ?? "N/A"},{" "}
            {deliveryDetails?.landmark ?? "N/A"},
            {deliveryDetails?.street ?? "N/A"},{" "}
            {deliveryDetails?.pin_code ?? "N/A"}
          </div>
        </div>):""}
        <hr />
        {vendorDetails?<div>
          <h3 style={{ fontWeight: "700", marginBottom: "8px" }}>Vendor Details</h3>
          <p>{vendorDetails?.first_name || ""}</p>
        </div>:""}
        <hr />
        <div>
          <h3 style={{ fontWeight: "700", marginBottom: "8px" }}>Product Details</h3>
          <div style={{  marginBottom: "8px" }}>
            <b>Product:</b> {ProductDeatils?.product?.name || ""}
          </div>
          <div style={{  marginBottom: "8px" }}>
            <b>Quantity:</b> {ProductDeatils?.quantity || ""}
          </div>
          <div style={{ marginBottom: "8px" }}>
            Product Base Price:{" "}
            {formattedAmount(
              parseFloat(
                item?.sales_price?.$numberDecimal || item?.sales_price
              ).toFixed(2)
            )}
          </div>
          <div style={{  marginBottom: "8px" }}>
            Total Price:{" "}
            {formattedAmount(
              parseFloat(
                ProductDeatils?.price?.$numberDecimal || ProductDeatils?.price
              ).toFixed(2)
            )}
          </div>
        </div>
        <hr />
        <div id="mid">
          <div className="info">
          <h3>Tax Details</h3>
          </div>
        </div>

        <div id="bot">
          <table style={{ border: "1px solid #ccc", width:"80%" }}>
            <thead>
              <tr style={{ border: "1px solid #ccc" }}>
                <th>Tax Name</th>
                <th className="text-right">Rate</th>
                <th className="text-right">Amount</th>
              </tr>
            </thead>
            <tbody>
              {item?.taxData?.standardTax?.map((t, i) => (
                <tr key={i} >
                  <td style={{ borderRight: "1px solid #ccc" }}>{t.name}</td>
                  <td className="text-right" style={{ borderRight: "1px solid #ccc" }}>{t?.rate.$numberDecimal || t?.rate}%</td>
                  <td className="text-right">
                    {formattedAmount(
                      t?.taxAmount?.$numberDecimal || t?.taxAmount
                    )}
                  </td>
                </tr>
              ))}

              <tr>
                <td style={{ borderRight: "1px solid #ccc" }}>Line Rebase</td>
                <td style={{ borderRight: "1px solid #ccc" }}></td>
                <td className="text-right" style={{ borderRight: "1px solid #ccc" }}>
                  {formattedAmount(
                    item?.taxData?.rebase?.$numberDecimal ||
                      item?.taxData?.rebase
                  )}
                </td>
              </tr>
              <tr>
                <td style={{ borderRight: "1px solid #ccc" }}>Referral Fee</td>
                <td className="text-right" style={{ borderRight: "1px solid #ccc" }}>
                  {item?.taxData?.adminEarning?.referralFee?.percentage
                    ?.$numberDecimal ||
                    item?.taxData?.adminEarning?.referralFee?.percentage}
                  %
                </td>
                <td className="text-right" style={{ borderRight: "1px solid #ccc" }}>
                  {formattedAmount(
                    item?.taxData?.adminEarning?.referralFee?.amount
                      ?.$numberDecimal ||
                      item?.taxData?.adminEarning?.referralFee?.amount
                  )}
                </td>
              </tr>
              <tr>
                <td style={{ borderRight: "1px solid #ccc" }}>Closing Fee</td>
                <td className="text-right" style={{ borderRight: "1px solid #ccc" }}>
                  {item?.taxData?.adminEarning?.closingFeeRate
                    ?.$numberDecimal ||
                    item?.taxData?.adminEarning?.closingFeeRate}
                </td>
                <td className="text-right" style={{ borderRight: "1px solid #ccc" }}>
                  {formattedAmount(
                    item?.taxData?.adminEarning?.closingFee?.$numberDecimal ||
                      item?.taxData?.adminEarning?.closingFee
                  )}
                </td>
              </tr>
              <tr>
                <td style={{ borderRight: "1px solid #ccc" }}>Additional Fee</td>
                <td className="text-right" style={{ borderRight: "1px solid #ccc" }}>
                  {item?.taxData?.additionalFee?.$numberDecimal ||
                    item?.taxData?.additionalFee}
                </td>
                <td className="text-right" style={{ borderRight: "1px solid #ccc" }}>
                  {formattedAmount(
                    item?.taxData?.adminEarning?.additionalFee
                      ?.$numberDecimal ||
                      item?.taxData?.adminEarning?.additionalFee
                  )}
                </td>
              </tr>
              <tr>
                <td style={{ borderRight: "1px solid #ccc" }}>Taxable Amount</td>
                <td style={{ borderRight: "1px solid #ccc" }}></td>
                <td className="text-right" style={{ borderRight: "1px solid #ccc" }}>
                  {formattedAmount(
                    item?.taxData?.taxableAmount?.$numberDecimal ||
                      item?.taxData?.taxableAmount
                  )}
                </td>
              </tr>
              <tr>
                <td style={{ borderRight: "1px solid #ccc"  }}>VAT Included</td>
                <td className="text-right" style={{ borderRight: "1px solid #ccc" }}>
                  {item?.taxData?.vat[0]?.rate?.$numberDecimal ||
                    item?.taxData?.vat[0]?.rate}
                  %
                </td>
                <td className="text-right" style={{ borderRight: "1px solid #ccc" }}>
                  {formattedAmount(
                    item?.taxData?.vat[0]?.taxAmount?.$numberDecimal ||
                      item?.taxData?.vat[0]?.taxAmount
                  )}
                </td>
              </tr>
                      
            </tbody>
            <thead>   
            <tr>
                <th  className="text-right" colSpan={2} style={{ borderRight: "1px solid #ccc" ,borderTop: "1px solid #ccc"}}>Total Price</th>
                
                <th className="text-right" style={{ borderRight: "1px solid #ccc" ,borderTop: "1px solid #ccc"}}>
                  {formattedAmount(
                    item?.taxData?.grandTotal?.$numberDecimal ||
                      item?.taxData?.grandTotal
                  )}
                </th>
              </tr>            
              <tr>
              <th colSpan={2} className="text-right" style={{ borderRight: "1px solid #ccc" }}>Quantity</th>
              <th  className="text-right" style={{ borderRight: "1px solid #ccc" }}> {ProductDeatils?.quantity || ""} </th>
              </tr>
              <tr>
              <th colSpan={2} className="text-right" style={{ borderRight: "1px solid #ccc" }}>Net Total</th>
              <th className="text-right" style={{ borderRight: "1px solid #ccc" }}>   {formattedAmount(
             parseFloat(
               ProductDeatils?.price?.$numberDecimal || ProductDeatils?.price
             ).toFixed(2))} </th>
              </tr>
            </thead>
            {/* <tbody>
          <tr>
                      
               <td className="text-right"> 
               {formattedAmount(
                   item?.taxData?.grandTotal?.$numberDecimal ||
                     item?.taxData?.grandTotal
                 )} 
               </td>
               <td className="text-right">
               {ProductDeatils?.quantity || ""} 
               </td>
               <td className="text-right"> 
                 
                  {formattedAmount(
             parseFloat(
               ProductDeatils?.price?.$numberDecimal || ProductDeatils?.price
             ).toFixed(2)
           )}</td>             
                
              </tr>
              </tbody> */}
          </table>        
         
        </div>
      </div>
    );
  }
};
export default TaxData;
